<mat-form-field>
  <mat-label class="select-placeholder-container">
    <span>{{ 'value' | translate }}</span>
    <mat-spinner *ngIf="loading$ | async" class="spinner" diameter="20"></mat-spinner>
  </mat-label>

  <input type="search" #searchInput [formControl]="fieldControl" matInput [matAutocomplete]="auto">
  <button *ngIf="searchInput.value.length > 0" matSuffix mat-icon-button (click)="$event.stopPropagation(); fieldControl.setValue(null)">
    <mat-icon svgIcon="close"></mat-icon>
  </button>

  <mat-autocomplete #auto="matAutocomplete" panelWidth="auto" [displayWith]="displayFn">
    <mat-option *ngFor="let value of filteredValues$ | async" [value]="value.id">
      {{ value.displayValue }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>